module.exports = __webpack_public_path__ + "static/img/desktop-gzxjck.4b5c4800.png";